__webpack_require__.p = "/webjars/progressive-bgp-update-visualization-ui/1.0.0-SNAPSHOT/";